module.exports = __webpack_public_path__ + "static/media/gmail-attachment-correct.2454a248.png";